<template>
  <div style="display: inline">
    <el-popover
        placement="right"
        title=""
        width="100"
        trigger="hover"
        content="">
      <el-button @click="showHistoryList">查看导出历史记录</el-button>
      <el-link type="primary" slot="reference" @click="createFile"
               style="margin-right:0;"
               :disabled="loadingBtn">
        <i class="el-icon-download"></i>{{ loadingBtn === true ? '导出中...' : '导出' }}
      </el-link>
    </el-popover>
    <div style="text-align: center">
      <ApeDrawer :drawerData="drawerData" @drawerClose="drawerClose">
        <template slot="ape-drawer">
          <div style="text-align: left">
            <div class="default-table">
              <ApeTable ref="downloadHistoryTable"
                        :data="dataList"
                        :columns="columns"
                        :loading="loadingStatus"
                        :pagingData="pagingData"
                        @switchPaging="switchPaging"
                        highlight-current-row
                        border>
                <el-table-column
                    slot="first-column"
                    width="60"
                    label="序号">
                  <template slot-scope="scope">
                    <span>{{ offset + scope.$index + 1 }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="120"
                    label="耗时" align="center">
                  <template slot-scope="scope">
                    <span>
                      {{ scope.row.end_time > 0 ? ((scope.row.end_time - scope.row.start_time) / 1000) : '/' }} 秒
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="120"
                    label="状态" align="center">
                  <template slot-scope="scope">
                    <el-tag :type="statusClassMap[scope.row.status]" size="mini">
                      {{ statusMap[scope.row.status] || '' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="created_at" width="120" label="创建时间" align="center"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="updated_at" width="120" label="修改时间" align="center"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column
                    key="操作项"
                    label="操作项"
                    header-align="center"
                    align="center"
                    width="160"
                    fixed="left"
                >
                  <template slot-scope="scope">
                    <el-link type="primary" style="padding: 0 0"
                             @click="downloadFile(scope.row)" size="mini"
                             :disabled="scope.row.status!=='DONE'"
                    ><i class="el-icon-download"></i>下载
                    </el-link>
                    &nbsp;
                    &nbsp;
                    <el-link type="danger" size="mini" @click="deleteBtn(scope.row.id)"><i class="el-icon-delete"></i>删除
                    </el-link>
                  </template>
                </el-table-column>
              </ApeTable>

            </div>
          </div>
        </template>
      </ApeDrawer>
    </div>

  </div>
</template>

<script>
import {
  createDownloadFileList,
  deleteDownloadFile,
  downloadFileExport,
  getDownloadFileList
} from "@/api/download_file";
import ApeDrawer from "@/components/ApeDrawer";
import ApeTable from "@/components/ApeTable";

export default {
  name: "AccountExport",
  props: {
    searchCondition: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      source_type: 'ad_account',
      loading: false,
      loadingBtn: false,
      // 抽屉数据
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        // direction: 'right',
        title: '导出历史记录',
        width_height: '1200px',
        show_footer: false,
        // mask: false,
        // close_name: '关 闭',
        // confirm_name: '打 印',
      },
      dataList: [],
      loadingStatus: false,
      // 分页信息
      pagingData: {
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        page_size: 20,
        // offset: 0
      },
      // 分页的offset,序号列使用
      offset: 0,
      columns: [
        { title: '编号', value: 'id' },
        { title: '标题', value: 'title', 'width': 200 },
        { title: '数据量', value: 'rows_count', align: 'right', header_align: "center" },
        { title: '下载次数', value: 'download_count', align: 'right', header_align: "center" },
        // { title: '状态', value: 'status' },
      ],
      statusMap: {
        'WAIT': '待生成',
        'DOING': '生成中...',
        'DONE': '生成完毕',
      },
      statusClassMap: {
        'WAIT': 'info',
        'DOING': 'warning',
        'DONE': 'success',
      }
    }
  },
  components: {
    ApeTable,
    ApeDrawer
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  methods: {
    async createFile() {
      if (!this.searchCondition.start_time) {
        this.$notify.success('导出时间范围必选');
        return
      }
      this.loadingBtn = true
      await createDownloadFileList({
        source_type: this.source_type,
        search_condition: this.searchCondition
      }).then(res => {
        return res.model

      })
      this.$notify.success('正在生成导出文件，请稍后下载');
      this.loadingBtn = false
    },
    showHistoryList() {
      this.drawerData.visible = true
      this.drawerData.loading = false

      this.$nextTick(() => {
        this.init()
      })

    },
    async drawerClose() {
      this.drawerData.visible = false
      this.drawerData.loading = true
    },
    drawerConfirm() {
    },
    async downloadFile(row) {
      this.exportLoading = true
      row.download_count += 1
      const searchCondition = { id: row.id }

      try {
        let isFileSaverSupported = !!new Blob()
        // console.log('isFileSaverSupported', isFileSaverSupported)
        if (isFileSaverSupported) {
          const response = await downloadFileExport(searchCondition).then(response => {
            return response
          })
          this.exportLoading = false
          const data = response.data
          const contentType = response.headers['content-type']
          const name = `广告订单-回款记录`
          const blob = new Blob([data], {
            type: contentType
          })

          this.FileSaver.saveAs(blob, decodeURI(name + '.xlsx'), { autoBom: true })
        } else {
          this.$message.warning('浏览器不支持导出文件')
        }
      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
        // alert(JSON.stringify(e))
      }
    },
    init() {
      this.$refs['downloadHistoryTable'].handleCurrentChange(1)
    },
    async initList(type) {
      this.loadingStatus = true
      let pagingInfo = this.$refs['downloadHistoryTable'].getPagingInfo(type)
      let searchCondition = { source_type: this.source_type };
      Object.assign(searchCondition, { page: pagingInfo.current_page, per_page: pagingInfo.page_size })
      let { list, pages } = await getDownloadFileList(searchCondition).then(res => {
        return res.model
      });

      this.$nextTick(() => {
        this.dataList = list
      })

      this.pagingData.total = pages.total
      this.offset = (pages.current_page - 1) * pages.per_page

      this.loadingStatus = false

    },
    // 切换页码操作
    async switchPaging() {
      this.initList()
    },

    //删除记录
    deleteBtn(id) {
      this.$msgbox.confirm('此操作将永久删除该导出记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteRow(id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //删除
    async deleteRow(id) {
      await deleteDownloadFile({ id: id }).then(res => {
        return res.model
      })

      this.$nextTick(() => {
        this.initList('del')
      })

    }
  }
}
</script>

<style scoped>

</style>
